module.exports = __webpack_public_path__ + "img/aj-1980-new.ef1b0ff5.jpg";